import { getStrSeparatedByUpperCase } from '../../helpers/getStrSeparatedByUpperCase'

import { getFormedEltTranslation } from './getFormedEltTranslation'

export const getFormedEltTranslationForKeys = (key: string) =>
  getFormedEltTranslation(getStrSeparatedByUpperCase(key))
